import Formatter from './Formatter';
import Helpers from './Helpers';
import Utils from './Utils';

const ReportComponent = {
    formatter: Formatter,
    getParams: Helpers.getParams,
    utils: Utils,
};

export default ReportComponent;
